<template>
    <div class="split-container">
        <div v-if="loading" class="loading-register-container">
            <div id="loading-register"></div>
        </div>
        <div class="split-container__left">
            <div class="left-side-content">
                <div class="left-side-content__logo">
                    <a :href="`/${$route.params.lang || ''}`">
                        <img :src="require('@/assets/interview-logo-register-page.png')" alt="interview.co" />
                    </a>
                </div>
                <div class="left-side-content__text">
                    <h1>
                        {{ resource["registerPresentationTitle"] }}
                    </h1>
                    <h2>
                        {{ resource["registerPresentationDesc"] }}
                    </h2>
                    <div class="d-flex align-items-center mb-2">
                        <i class="icon-tick-rounded"/> <p v-html="resource['registerPresentationDescOne']"></p>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                        <i class="icon-tick-rounded" /> <p v-html="resource['registerPresentationDescTwo']"></p>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                        <i class="icon-tick-rounded" /> <p v-html="resource['registerPresentationDescThree']"></p>
                    </div>
                    <div class="d-flex mb-2">
                        <i class="icon-tick-rounded" /> <p v-html="resource['registerPresentationDescFour']"></p>
                    </div>
                    <div class="d-flex mb-2">
                        <i class="icon-tick-rounded" /> <p v-html="resource['registerPresentationDescFive']"></p>
                    </div>
                    <div class="d-flex mb-2">
                        <i class="icon-tick-rounded" /> <p v-html="resource['registerPresentationDescSix']"></p>
                    </div>
                </div>
                <div class="left-side-content__carousel">
                    <logo-carousel :itemsToShow="5" :itemsToSlide="1" :autoPlay="true" :playSpeed="1000" :initialSlide="0.5" :transition="900" :infiniteScroll="true" :images="images"/>
                    <!-- <venue-carousel :images="images" :autoplayInterval="5000"/> -->
                </div>
                <div class="split-container__mobile">
                    <logo-carousel :itemsToShow="3.75" :itemsToSlide="1" :autoPlay="true" :playSpeed="1000" :transition="900" :infiniteScroll="true" :images="images" />
                    <!-- <venue-carousel :images="images" :autoplayInterval="5000"/> -->
                </div>
            </div>
        </div>
        <div class="split-container__right">
            <div class="right-side-content">
                <div id="zf_div_9Wtd6ZRLjuquNJWx4r5uvUXC--YRFnTIeZhM-PZ7PS0"></div>
                <div v-if="!loading" class="register-text">
                    {{ resource["registerPage.LoginText"] }}
                    <router-link :to="{
                    name: 'LoginView',
                    params: { lang: $route.params.lang },
                    }" class="login-link">
                        {{ resource["registerPage.LoginLink"] }}
                    </router-link>
                    <br/><br/>
                    <a :href="`https://interview.co/${$route.params.lang ? `${$route.params.lang}/` : ''}register`"  class="login-link">
                        {{ resource["registerPage.JobSeekerLink"] }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResourceManager from '@/services/resource.service';
import LogoCarousel from '../common/LogoCarousel';
// import VenueCarousel from '../common/VenueCarousel.vue';

export default {
  name: 'Register',

  metaInfo: {
    meta: [
      { name: 'description', content: 'Sign up to interview.co and manage your interview process in 3 easy steps.' },
    ],
  },

  components: {
    LogoCarousel,
  },

  data() {
    return {
      loading: true,
      images: [
        { src: require('../../assets/images/borusan-carousel.png') },
        { src: require('../../assets/images/perfetti-carousel.png') },
        { src: require('../../assets/images/migros-carousel.png') },
        { src: require('../../assets/images/danone-carousel.png') },
        { src: require('../../assets/images/hm-carousel.png') },
        { src: require('../../assets/images/roche-logo.svg') },
        { src: require('../../assets/images/petrol-ofisi-logo.svg') },
        { src: require('../../assets/images/gsk.png') },
        { src: require('../../assets/images/pepsico-logo.svg') },
        { src: require('../../assets/images/mapfre-logo.svg') },
        { src: require('../../assets/images/cigna-logo.svg') },
        { src: require('../../assets/images/socar-logo.svg') },
      ],
    };
  },

  mounted() {
    const currentLang = this.$route.params.lang || 'en';
    const lang = ResourceManager.CurrentLang || 'en-EN';
    const url = `https://forms.zohopublic.eu/techcareer122/form/SignUpNew/formperma/OHYHjqlOj5Na9TzdI1lRsMdmY8fegsAQl-OaS7h57Fs?zf_lang=${currentLang || 'en'}&SingleLine3=${lang || 'en-EN'}&zf_rszfm=1`;

    const f = document.createElement('iframe');
    f.src = url;
    f.style.border = 'none';
    f.style.height = '697px';
    f.style.width = '100%';
    f.style.transition = 'all 0.5s ease';

    const d = document.getElementById('zf_div_9Wtd6ZRLjuquNJWx4r5uvUXC--YRFnTIeZhM-PZ7PS0');
    d.appendChild(f);
    window.addEventListener('message', () => {
      const evntData = event.data;
      if (evntData && evntData.constructor === String) {
        const IframeData = evntData.split('|');
        if (IframeData.length === 2) {
          const ZfPerma = IframeData[0];
          const ZfIfrmHtNw = `${parseInt(IframeData[1], 10) + 15}px`;
          const iframe = document.getElementById('zf_div_9Wtd6ZRLjuquNJWx4r5uvUXC--YRFnTIeZhM-PZ7PS0').getElementsByTagName('iframe')[0];
          if ((iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(ZfPerma) > 0) {
            const prevIframeHeight = iframe.style.height;
            this.loading = false;
            if (prevIframeHeight !== ZfIfrmHtNw) {
              iframe.style.height = ZfIfrmHtNw;
            }
          }
        }
      }
    }, false);
  },

  methods: {},

};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.split-container {
    width: 100%;
    min-height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    text-align: left;
    overflow: auto;

    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        flex-direction: column-reverse;
    }

    &__left {
        background: #FFF;
        width: 55%;
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100%;

        @media only screen and (max-width: 1150px) {
            width: 50%;
            min-height: auto;
        }

        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            width: 100%;
            min-height: auto;
        }

        &:has(.left-side-content__mobile-carousel) {
            @media only screen and (min-width: map-get($grid-breakpoints, 'lg')) {
                display: none;
            }
        }
    }

    &__right {
        background: $orange-primary;
        display: flex;
        width: 45%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-self: stretch;
        min-height: 100%;

        @media only screen and (max-width: 1150px) {
            width: 50%;
            min-height: auto;
            background: #FFFFFF;
        }

        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            width: 100%;
            min-height: auto;
            flex: 1;
        }
    }

    &__mobile {
        background: #FFF;
        padding: 16px 0;
        width: 100%;

        @media only screen and (min-width: map-get($grid-breakpoints, 'lg')) {
            display: none;
        }
    }

    .left-side-content {
        margin: 0 auto;
        max-width: 488px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        gap: 48px;
        min-height: 100%;

        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
            margin: 0px 16px;
            gap: 40px;
            width: calc(100% - 32px);
        }

        &__logo {
            img {
                margin-bottom: 16px;
                @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
                    width: 208px;
                    display:none
                }
            }
        }

        &__text {
            border-left: 2px solid #666666;
            padding-left: 32px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: start;

            @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
                padding-left: 24px;
            }

            h1 {
                font-family: Roboto !important;
                font-weight: 500;
                font-size: 26px;
                line-height: 32px;
                color: #4C4C4C;
                margin-bottom: 8px;

                @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
                    font-size: 28px;
                    line-height: 36px;
                }
            }

            h2 {
                font-family: Roboto !important;
                font-weight: 500;
                font-size: 20px;
                line-height: 24px;
                color: #4C4C4C;
                margin-bottom: 24px;

                @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
                    font-size: 18px;
                    line-height: 24px;
                }
            }
            p {
                font-family: Roboto !important;
                font-weight: 400;
                font-size: 16px;
                line-height: 130%;
                color: #4C4C4C;
                margin-bottom: 0px;

                @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
                    font-size: 18px;
                    line-height: 24px;
                }

                ::v-deep span {
                    font-weight: 500 !important;
                }
            }
            i {
                font-size: 20px;
                margin-right: 4px;
            }
        }

        &__carousel {
            max-width: 488px;

            @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
                display: none;
            }
        }
    }

    .right-side-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 100%;

        .register-text {
            border-bottom-right-radius: 20px;
            border-bottom-left-radius: 20px;
            padding: 0 0 20px;
            text-align: center;
            background: #FFF;
            color: #858585;
            width: 356px;
            position: relative;
            top: -20px;

            @media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {
                width: 95%;
                padding-bottom: 0px;
            }

            p {
                color: #777;
            }

            a {
                color: #FF8D06;
                text-decoration: none;
            }
        }
    }
}

.loading-register-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    right: 0;
    border: 0;
    top: 0;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    z-index: 4444;
}

#loading-register {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid #e6e6e6;
    border-radius: 50%;
    border-top-color: #ff8d06;
    animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
    -webkit-animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}

#zf_div_9Wtd6ZRLjuquNJWx4r5uvUXC--YRFnTIeZhM-PZ7PS0 {
    width: 356px;
    background: #FFF !important;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    margin-top: 24px;

    @media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {
        width: 95%;
    }
}
</style>
